export const environment = {
  production: true,
  apiBaseUrl: 'https://openapi.styret.com/',
  subscriptionKey: 'ecff5936f16949339e36964a50f0c62e',
};
